import { SetGetJackpotHistoryList } from './thunk/setGetJackpotHistoryList'

export const Thunks = {
    SetGetJackpotHistoryList
}